import axiosInstance from "../axiosConfig";
import { ADMIN_API_URL } from "../config/apiParams";

export const getLookupValuesAPI = async (headData, lookupType) => {
    const { access_token, token_type, organisationId, projectId } = headData;

    const headers = {
        'accept': 'application/json',
        'org-id': `${organisationId}`,
        'proj-id': `${projectId}`,
        'Authorization': `${token_type} ${access_token}`
    }

    const response = await axiosInstance({
        url: `${ADMIN_API_URL}/lookup/${lookupType}`,
        method: "GET",
        headers: headers,
    });

    return response || null;
}